/**
 * Copy for a stalled or dropped request. The same sentences are used by the
 * fetch retry and by the screens that used to show WebKit's "Load failed".
 */

const RETRYING_MESSAGE = 'Connection problem, retrying\u2026';
const CONNECTION_FAILURE_MESSAGE = "Couldn't connect. Check your connection and try again.";

const NETWORK_TEXT = /load failed|failed to fetch|networkerror|network request failed|failed to load|the internet connection appears to be offline|couldn't connect|could not connect|timeout/i;

function isConnectionFailure(error) {
  if (!error) return false;
  if (error.code === 'connection' || error.name === 'ConnectionError' || error.name === 'TimeoutError') {
    return true;
  }
  const message = String(error.message || error.error_description || error.msg || '');
  if (NETWORK_TEXT.test(message)) return true;
  if (error.name === 'AbortError' && /abort|timeout/i.test(message)) return true;
  return false;
}

function connectionError(cause) {
  const error = new Error(CONNECTION_FAILURE_MESSAGE);
  error.code = 'connection';
  error.name = 'ConnectionError';
  if (cause) error.cause = cause;
  return error;
}

function presentConnectionError(error, fallback) {
  if (isConnectionFailure(error)) return CONNECTION_FAILURE_MESSAGE;
  if (fallback) return fallback;
  return error && error.message ? String(error.message) : CONNECTION_FAILURE_MESSAGE;
}

module.exports = {
  RETRYING_MESSAGE,
  CONNECTION_FAILURE_MESSAGE,
  isConnectionFailure,
  connectionError,
  presentConnectionError,
};
